import { render, staticRenderFns } from "./userIcon.vue?vue&type=template&id=f7e9b52a&"
import script from "./userIcon.vue?vue&type=script&lang=js&"
export * from "./userIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports